<template>
  <div>
    <template v-if="projectForm">
      <Divider title="项目基础信息"></Divider>
      <el-form
        v-if="projectForm"
        ref="formRef"
        :validate-on-rule-change="false"
        :model="projectForm"
        :rules="getProjectFormRules.call(projectForm)"
        label-width="130px"
      >
        <el-form-item label="项目名称" prop="project_name">
          <DynamicWordsInput v-model="projectForm.project_name" :words="projectDynamicWords">
            <el-input
              reference="input"
              style="width: 320px"
              v-model="projectForm.project_name"
              placeholder="最大90个字符, 一个中文等于2个字符"
            ></el-input>
          </DynamicWordsInput>
        </el-form-item>
        <el-form-item label="应用平台" prop="ch_platform_id">
          <el-radio-group v-model="projectForm.ch_platform_id" @change="onPlatformChange">
            <el-radio-button ghost :label="PLATFORM.ANDROID"> 安卓应用 </el-radio-button>
            <el-radio-button ghost :label="PLATFORM.IOS"> IOS应用 </el-radio-button>
            <el-radio-button ghost :label="PLATFORM.MINI_PROGRAM"> 小程序 </el-radio-button>
            <el-radio-button ghost :label="PLATFORM.HARMONY"> 鸿蒙应用 </el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="应用" prop="game.id">
          <el-select v-model="projectForm.game" @change="onGameChange" value-key="id" filterable style="width: 320px">
            <el-option v-for="game in gameListFilterdByPlatform" :key="game.id" :label="game.name" :value="game"></el-option>
          </el-select>
          <p v-if="projectForm.game.id">
            <span v-if="projectForm.game.ad_package">应用包名：{{ projectForm.game.ad_package }}</span>
            <span v-else>包名信息未配置，请前往开放系统-游戏管理进行配置</span>
          </p>
        </el-form-item>
        <el-form-item label="回调开关" prop="callback_switch">
          <el-switch v-model="projectForm.callback_switch" :active-value="1" :inactive-value="0"> </el-switch>
          <p class="important-notice">注意：IOS一定要开启，安卓接了头条SDK或小程序平台的推广目的为应用APP（微端）时请关闭！</p>
        </el-form-item>

        <el-form-item
          label="头条分包"
          prop="toutiaoAcid"
          v-if="projectForm.ch_platform_id === PLATFORM.ANDROID && projectForm.app_promotion_type === APP_PROMOTION_TYPE.DOWNLOAD"
        >
          <div v-if="projectForm.game.id">
            <span v-if="projectForm.game.toutiaoAcid">分包功能正常</span>
            <span v-else>该应用未配置头条分包信息，不能使用头条分包功能，请更换应用或者找相关运营进行配置</span>
          </div>
          <div v-if="projectForm.game.toutiaoAcid">
            <p>头条应用账号ID：{{ projectForm.game.toutiaoAcid }}</p>
            <p>头条应用ID：{{ projectForm.game.toutiaoAppid }}</p>
          </div>
        </el-form-item>

        <!-- 搜索广告并且常规投放才能设置蓝海流量 -->
        <!-- <template v-if="isSearch && isNormal">
        <el-form-item label="蓝海流量投放" prop="blue_flow_package">
          <el-radio-group v-model="projectForm.blue_flow_package.blue_flow_package_setting">
            <el-radio-button ghost :label="BLUE_FLOW_PACKAGE_SETTING_SWITCH.OFF"> 不启用 </el-radio-button>
            <el-radio-button ghost :label="BLUE_FLOW_PACKAGE_SETTING_SWITCH.ON"> 启用 </el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item v-if="projectForm.blue_flow_package.blue_flow_package_setting === BLUE_FLOW_PACKAGE_SETTING_SWITCH.ON">
          <BlueFlowPackageTable
            v-model="projectForm.blue_flow_package.blue_flow_package_id"
            :account-id="accountId"
            @change="onBlueFlowPackageChange"
          ></BlueFlowPackageTable>
        </el-form-item>
      </template> -->
      </el-form>

      <Divider title="营销目的及场景"></Divider>
      <el-form
        ref="marketingSceneFormRef"
        :validate-on-rule-change="false"
        :model="projectForm"
        :rules="getProjectFormRules.call(projectForm)"
        label-width="130px"
      >
        <MarketingSceneForm :form="projectForm"> </MarketingSceneForm>
      </el-form>

      <!-- 手动投放才能显示搜索快投 -->
      <template v-if="isManual && projectForm.ad_type === AD_TYPE.ALL">
        <Divider title="搜索快投"></Divider>
        <el-form
          ref="keywordSearchFormRef"
          :validate-on-rule-change="false"
          :model="projectForm"
          :rules="getProjectFormRules.call(projectForm)"
          label-width="130px"
        >
          <KeywordSearchForm :form="projectForm">
            <template #searchBidKeywordsSelectBtn>
              <el-button type="text" @click="onSearchKeywordAdd">编辑</el-button>
            </template>
          </KeywordSearchForm>
        </el-form>
      </template>

      <Divider title="排期和出价设置"></Divider>
      <el-form
        ref="bidFormRef"
        :validate-on-rule-change="false"
        :model="projectForm"
        :rules="getProjectFormRules.call(projectForm)"
        label-width="130px"
      >
        <BidForm :form="projectForm"> </BidForm>
      </el-form>

      <p style="padding-bottom: 60px"></p>
    </template>

    <!-- 搜索快投选择弹窗 -->
    <SearchBidKeywordSelectModal
      v-model="showSearchBidKeywordModal"
      :account-id="accountId"
      :list="searchBidKeywordList"
      @confirm="onSearchKeywordSelectConfirm"
    ></SearchBidKeywordSelectModal>
  </div>
</template>

<script setup>
import { computed, ref, unref, inject } from 'vue'
import { PLATFORM } from '@/common/js/constants.js'
import {
  TOUTIAO_PROJECT_DYNAMIC_WORDS,
  APP_PROMOTION_TYPE,
  DELIVERY_TYPE,
  AD_TYPE,
  AUDIENCE_EXTEND,
  BID_TYPE,
  BLUE_FLOW_PACKAGE_SETTING_SWITCH
} from '../../consts/index.js'
import Divider from '../layout/title-divider.vue'

import DynamicWordsInput from '@/components/dynamic-words-input/index.vue'
import SearchBidKeywordSelectModal from './components/search-bid.vue'
import MarketingSceneForm from './marketing-scene-form.vue'
import BidForm from './bid-form.vue'
import KeywordSearchForm from './keyword-search-form.vue'

// import BlueFlowPackageTable from './components/blue-flow-package-table.vue'
import { getProjectFormRules } from '../../rules/index.js'
import { adAccount, checkGameInfo, checkPlanName, getCaoHuaGames } from '@/api/common.model'
import { useProjectForm, useMarketingSceneForm } from './useProject.js'
import { useSearchBid } from '../../hooks/useToutiaoBasic.js'

const formRef = ref(null)
const marketingSceneFormRef = ref(null)
const bidFormRef = ref(null)
const keywordSearchFormRef = ref(null)
const projectForm = ref(null)
const { configForm, updateConfigForm } = inject('configForm')
const { isV3 } = inject('bytedanceVersion', { isV3: computed(() => false) })
const projectDynamicWords = computed(() =>
  isV3.value ? TOUTIAO_PROJECT_DYNAMIC_WORDS.filter((word) => word !== '计划组名') : TOUTIAO_PROJECT_DYNAMIC_WORDS
)

const [
  { budgetOptimizeSwitchVisible, deepBidTypeVisible, deepExternalActionVisible },
  {
    onPlatformChange,
    onGameChange,
    // onBlueFlowPackageChange,
    onExternalTypeChange,
    onBidTypeChange,
    onDeepBidTypeChange,
    onBudgetModeChange
  }
] = useProjectForm(projectForm, formRef)

const { isManual, gameListFilterdByPlatform } = useMarketingSceneForm(projectForm, formRef)

const { accountId, showSearchBidKeywordModal, searchBidKeywordList, onSearchKeywordAdd } = useSearchBid(configForm)

/**
 * @description: 处理搜索快投选择逻辑
 * @param {*} keywords
 */
function onSearchKeywordSelectConfirm(keywords) {
  const form = {
    ...projectForm.value,
    keywords: keywords.map((item) => ({
      word: item.keyword,
      bid_type: 'FEED_TO_SEARCH',
      match_type: item.patern.value
    })),
    keywordsDesc: ''
  }

  searchBidKeywordList.value = keywords

  const len = keywords.length
  if (len) {
    const [firstItem] = keywords
    form.keywordsDesc = `已选${firstItem.keyword}...共${len}个关键词`
  } else {
    form.keywordsDesc = '未添加关键词，待自动更新'
  }

  projectForm.value = form
}

// eslint-disable-next-line
defineExpose({
  setForm: (form) => (projectForm.value = form),
  getForm: () => unref(projectForm),
  validate: async () => {
    const validateFuns = [formRef.value.validate, marketingSceneFormRef.value.validate, bidFormRef.value.validate]
    if (keywordSearchFormRef.value) {
      validateFuns.push(keywordSearchFormRef.value.validate)
    }
    return Promise.all(validateFuns.map((fn) => fn()))
  }
})
</script>

<style lang="scss" scoped>
.important-notice {
  color: red;
  font-size: 12px;
}
</style>
